/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<
  defs.tms.IPage<defs.tms.CustomsClearanceDetailsResponseDto>
>;
export function request(
  params: API.tms.customsClearanceDetails.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsClearanceDetails/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
